import { uniq } from "lodash";

import { setInterestEarnedRangeByEid } from "@/redux/app/appReducers";
import { api } from "@/shared/api/api";
import type { TApiInterestAndTaxPaginatedPayload } from "@/shared/api/types/clientPortal";

const hasInterestOrTax = (row: TApiInterestAndTaxPaginatedPayload["data"][number]) =>
  Boolean(Number(row.tax) || Number(row.gross_interest) || Number(row.net_interest));

const yieldApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInterestAndTax: builder.query<TApiInterestAndTaxPaginatedPayload, string>({
      query: (eid) => `/interest_and_tax/${eid}`,
      async onQueryStarted(eid, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const months = uniq(data.data.filter(hasInterestOrTax).map((row) => row.task_date.slice(0, 7))).length;
          if (!months) return;
          dispatch(setInterestEarnedRangeByEid({ eid, range: [0, months - 1] }));
        } catch {
          // query errors handled elsewhere
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetInterestAndTaxQuery, endpoints } = yieldApi;
